// extracted by mini-css-extract-plugin
export var editButton = "_ni-0";